<script lang="ts">
	import { clickOutside } from '$lib/components/ClickOutside/clickOutside.js'

	export let tooltipInfo = ''
	export let tooltipStyle = ''
	export let tooltipDisableHover = true
	export let tooltipBottom = false


	let tooltipExpanded = false
	let fullTooltipStyle = ''
	$: {
		fullTooltipStyle = tooltipStyle + ' --tooltip-white-space: pre-wrap;'
		if (tooltipBottom) {
			fullTooltipStyle += `
							--tooltip-position: auto;
							--tooltip-position-top: 100%;
							--tooltip-arrow-top: none;
							--tooltip-arrow-bottom: 5px solid hsla(0, 0%, 20%, 0.9);
							--tooltip-margin-bottom: 0;`
		}
	}

	function handleToogleTooltip() {
		tooltipExpanded = !tooltipExpanded
	}
	function handleClickOutside() {
		if (tooltipExpanded) {
			tooltipExpanded = false
		}
	}

	function formatTitle(title: string) {
		let fmtTitle = title.replace(new RegExp('<br/>', 'g'), '\n')
		return fmtTitle
	}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
	class="hover:cursor-pointer flex items-center"
	data-tooltip={formatTitle(tooltipInfo)}
	tooltip-untrigger-hover={tooltipDisableHover || null}
	tooltip-visible={tooltipExpanded || null}
	tooltip-hidden={!tooltipExpanded || null}

	style={fullTooltipStyle}
	use:clickOutside
	on:click_outside={handleClickOutside}
	on:click|stopPropagation={() => handleToogleTooltip()}
>
	<slot />
</div>
